import LiquiditySummaryDataMessage from 'widgets/liquiditySummary/api/LiquiditySummaryDataMessage';
import { StreamDataHandlers } from 'streamsState/StreamDataService';
import LiquiditySummaryMessageBuffer from './LiquiditySummaryMessageBuffer';
import { Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildByStreamKeyHandlers } from 'streamsState/store/streamedData/handlers';
import { createReceiveMessageBatchAction } from 'streamsState/store/streamedData/actions';

export const buildLiquiditySummaryStreamHandlers: (
    store: Store,
    loggingService: LoggingService
) => StreamDataHandlers<LiquiditySummaryDataMessage> = (
    store,
    loggingService
) => {
    const dispatch = store.dispatch;

    let sKey: string | undefined;

    const messageBuffer = new LiquiditySummaryMessageBuffer(
        (streamKey: string, data: LiquiditySummaryDataMessage[]) => {
            dispatch(
                createReceiveMessageBatchAction(
                    'startLiquidityStream',
                    streamKey,
                    data
                )
            );
        },
        () => !!sKey!,
        loggingService
    );

    const handlers = buildByStreamKeyHandlers(store, 'startLiquidityStream');

    return {
        ...handlers,
        onMessage: (
            streamKey: string,
            message: LiquiditySummaryDataMessage
        ) => {
            messageBuffer.in(streamKey, [message]);
        },
    };
};
